'use client'
export const dynamic = 'force-dynamic'
import { useState } from 'react'

export default function ContributePage() {
  const [step, setStep] = useState<'info'|'form'|'done'>('info')
  const [form, setForm] = useState({ name:'', email:'', institution:'', qualification:'', expertise:'', bio:'', title:'', category:'', content:'', scholarName:'', excerpt:'' })
  const [submitting, setSubmitting] = useState(false)

  function set(k: string, v: string) { setForm(p=>({...p,[k]:v})) }

  /* real persistence: contributions land in the same reviewed store as contact
     messages (the old version faked success with a setTimeout) */
  const [failed, setFailed] = useState(false)
  async function submit() {
    setSubmitting(true)
    setFailed(false)
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name || form.scholarName || 'Contributor',
          email: form.email,
          subject: 'Article contribution',
          message: `Title: ${form.title}\nCategory: ${form.category}\nScholar: ${form.scholarName}\nQualification: ${form.qualification}\nInstitution: ${form.institution}\nExpertise: ${form.expertise}\n\nExcerpt: ${form.excerpt}\n\nBio: ${form.bio}\n\nContent:\n${form.content}`.slice(0, 4000),
        }),
      })
      const d = await res.json().catch(() => null)
      if (d?.ok) setStep('done')
      else setFailed(true)
    } catch {
      setFailed(true)
    }
    setSubmitting(false)
  }

  if (step === 'done') return (
    <div style={{ fontFamily:'Inter, sans-serif', minHeight:'100vh', background:'#f8f8f6', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'white', borderRadius:20, padding:48, textAlign:'center', maxWidth:480, boxShadow:'0 8px 32px rgba(0,0,0,0.08)' }}>
        <div style={{ fontSize:64, marginBottom:16 }}>✅</div>
        <h2 style={{ fontSize:22, fontWeight:800, color:'#0B132B', margin:'0 0 12px' }}>Article Submitted!</h2>
        <p style={{ color:'#555', fontSize:14, lineHeight:1.6, margin:'0 0 24px' }}>
          JazakAllahu Khairan for your contribution. Our editorial team will review your article and get back to you within 3–5 working days.
        </p>
        <button onClick={()=>setStep('info')} style={{ background:'#0E7C61', color:'white', border:'none', borderRadius:10, padding:'12px 28px', fontSize:14, fontWeight:700, cursor:'pointer' }}>
          Submit Another
        </button>
      </div>
    </div>
  )

  return (
    <div style={{ fontFamily:'Inter, sans-serif', minHeight:'100vh', background:'#f8f8f6' }}>
      <div style={{ background:'linear-gradient(135deg,#0B132B,#1a2a5e)', padding:'48px 20px' }}>
        <div style={{ maxWidth:720, margin:'0 auto', textAlign:'center' }}>
          <div style={{ fontSize:11, fontWeight:700, color:'#D4AF37', letterSpacing:2, textTransform:'uppercase', marginBottom:12 }}>Contributor Portal</div>
          <h1 style={{ fontSize:28, fontWeight:900, color:'white', margin:'0 0 12px' }}>Share Islamic Knowledge</h1>
          <p style={{ color:'rgba(255,255,255,0.88)', fontSize:15, margin:0 }}>Submit articles, research, and insights for the Muslim community</p>
        </div>
      </div>

      <div style={{ maxWidth:720, margin:'32px auto', padding:'0 20px 40px' }}>
        {step === 'info' && (
          <>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginBottom:28 }}>
              {[
                { icon:'✍️', title:'Write Your Article', desc:'Share knowledge in any Islamic topic — Fiqh, History, Society, Quran, Hadith' },
                { icon:'👨‍🏫', title:'Scholar Profile', desc:'Tell us your qualifications and credentials — we verify all contributors' },
                { icon:'📋', title:'Editorial Review', desc:'Our team reviews for authenticity and appropriateness before publishing' },
              ].map(s=>(
                <div key={s.title} style={{ background:'white', borderRadius:14, padding:20, textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                  <div style={{ fontSize:32, marginBottom:10 }}>{s.icon}</div>
                  <div style={{ fontWeight:700, color:'#0B132B', fontSize:14, marginBottom:6 }}>{s.title}</div>
                  <div style={{ color:'#888', fontSize:12, lineHeight:1.5 }}>{s.desc}</div>
                </div>
              ))}
            </div>
            <div style={{ textAlign:'center' }}>
              <button onClick={()=>setStep('form')} style={{ background:'#0E7C61', color:'white', border:'none', borderRadius:12, padding:'14px 36px', fontSize:16, fontWeight:700, cursor:'pointer' }}>
                Start Contributing →
              </button>
            </div>
          </>
        )}

        {step === 'form' && (
          <div style={{ display:'grid', gap:20 }}>
            {/* Scholar Info */}
            <div style={{ background:'white', borderRadius:16, padding:24, boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
              <h2 style={{ fontSize:16, fontWeight:700, color:'#0B132B', margin:'0 0 16px' }}>👨‍🏫 Your Details</h2>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                {[
                  {l:'Full Name',k:'name',p:'Sheikh/Dr./Mr. Full Name'},
                  {l:'Email Address',k:'email',p:'your@email.com'},
                  {l:'Institution / Organisation',k:'institution',p:'Darul Uloom, University, etc.'},
                  {l:'Qualification',k:'qualification',p:'Mufti, PhD Islamic Studies, etc.'},
                ].map(f=>(
                  <div key={f.k}>
                    <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>{f.l}</label>
                    <input value={(form as any)[f.k]} onChange={e=>set(f.k,e.target.value)} placeholder={f.p} style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:14, fontFamily:'inherit', boxSizing:'border-box' }}/>
                  </div>
                ))}
              </div>
              <div style={{ marginTop:16 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>Area of Expertise</label>
                <input value={form.expertise} onChange={e=>set('expertise',e.target.value)} placeholder="Fiqh, Tafsir, Islamic History, Islamic Finance..." style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:14, fontFamily:'inherit', boxSizing:'border-box' }}/>
              </div>
              <div style={{ marginTop:16 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>Short Bio</label>
                <textarea value={form.bio} onChange={e=>set('bio',e.target.value)} rows={3} placeholder="Brief professional bio..." style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:14, fontFamily:'inherit', boxSizing:'border-box', resize:'vertical' }}/>
              </div>
            </div>

            {/* Article */}
            <div style={{ background:'white', borderRadius:16, padding:24, boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
              <h2 style={{ fontSize:16, fontWeight:700, color:'#0B132B', margin:'0 0 16px' }}>📝 Your Article</h2>
              <div style={{ marginBottom:16 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>Article Title</label>
                <input value={form.title} onChange={e=>set('title',e.target.value)} placeholder="Enter a clear, informative title..." style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:15, fontFamily:'inherit', fontWeight:600, boxSizing:'border-box' }}/>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
                <div>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>Category</label>
                  <select value={form.category} onChange={e=>set('category',e.target.value)} style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:14, fontFamily:'inherit', background:'white', boxSizing:'border-box' }}>
                    <option value="">Select category</option>
                    {['Fiqh','Ibadah','Quran','Hadith','History','Society','Waqf','Finance','Youth','Women'].map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>Scholar Name (for byline)</label>
                  <input value={form.scholarName} onChange={e=>set('scholarName',e.target.value)} placeholder="As it should appear on the article" style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:14, fontFamily:'inherit', boxSizing:'border-box' }}/>
                </div>
              </div>
              <div style={{ marginBottom:16 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>Short Excerpt (2–3 sentences)</label>
                <textarea value={form.excerpt} onChange={e=>set('excerpt',e.target.value)} rows={3} placeholder="A brief summary shown in listings..." style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:14, fontFamily:'inherit', boxSizing:'border-box', resize:'vertical' }}/>
              </div>
              <div>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#555', marginBottom:6 }}>Full Article Content</label>
                <textarea value={form.content} onChange={e=>set('content',e.target.value)} rows={14} placeholder="Write your full article here. You can use Markdown formatting." style={{ width:'100%', padding:'12px', borderRadius:8, border:'1px solid #e8e8e8', fontSize:14, fontFamily:'inherit', boxSizing:'border-box', resize:'vertical', lineHeight:1.7 }}/>
              </div>
            </div>

            {failed && (
              <p style={{ fontSize:13, color:'#B4574E', margin:'0 0 12px' }}>
                The submission couldn&apos;t be saved right now — please email it to <a href="mailto:support@masjids.in" style={{ color:'#B4574E', fontWeight:600 }}>support@masjids.in</a> instead.
              </p>
            )}
            <div style={{ display:'flex', gap:12 }}>
              <button onClick={submit} disabled={submitting||!form.title||!form.content||!form.name} style={{ flex:1, background:'#0E7C61', color:'white', border:'none', borderRadius:12, padding:'14px', fontSize:15, fontWeight:700, cursor:'pointer', opacity:(!form.title||!form.content||!form.name)?0.5:1 }}>
                {submitting ? 'Submitting…' : 'Submit for Review'}
              </button>
              <button onClick={()=>setStep('info')} style={{ background:'white', color:'#888', border:'1px solid #e8e8e8', borderRadius:12, padding:'14px 24px', fontSize:14, fontWeight:600, cursor:'pointer' }}>Back</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
